// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"413ea3c1","603":"9f13bb66","787":"498e3191"}[chunkId] + ".chunk.js";
};